import script from "./ProductPopup.vue?vue&type=script&setup=true&lang=js"
export * from "./ProductPopup.vue?vue&type=script&setup=true&lang=js"

import "./ProductPopup.vue?vue&type=style&index=0&id=c7bd94c4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c7bd94c4"]])

export default __exports__